import React from "react";
import useStore from "../../../../store/UseStore";
import { appDeepLink } from "../../../../utils/constants";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import { handleDownloadAppClickedEvent } from "../../../../utils/helperEventFunctions";
import { useRouter } from "next/router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

const DownloadTheAppCTA = ({ className, onSection, animate }) => {
  const { setOpenQRModal } = useStore();
  const { isMobile } = useIsMobile();
  const router = useRouter();
  return (
    <button
      className={` ${animate ? "shiny-button" : ""} ${
        className || ""
      } bg-white text-black !px-5 !py-3 rounded-md flex items-center justify-center gap-x-2`}
      onClick={() => {
        handleDownloadAppClickedEvent({
          status: onSection,
          sourceScreen: router.pathname,
        });
        if (!isMobile) setOpenQRModal({ open: true, fromSection: onSection });
        else window.location.href = appDeepLink;
      }}
    >
      Download App{" "}
      <FontAwesomeIcon icon={faArrowDown} className="animate-bounce" />
    </button>
  );
};

export default DownloadTheAppCTA;
